export default {
  'description.header': {
    id: 'modelPopup.description.header',
    defaultMessage: 'Description'
  },
  'author.header': {
    id: 'modelPopup.author.header',
    defaultMessage: 'Author'
  }
};